module.exports = __webpack_public_path__ + "static/img/ms.72738a09.png";